import React, { Component } from 'react';
import _ from 'lodash';
import CrgtEvent from '../CrgtEvent';
import './index.scss';

export default class Container extends Component {
  
  render() {
    const { size='default', style, href, target, cid, vid, nativePage, nativePath, externalUrl, router, handleChangePage, event = 'doNothing' } = this.props;
    let containerClass = size === 'default' ? 'fullContainer' : 'partContainer';
    let params = {};
    if (event === 'openUrl') {
      params = (!_.isNil(href) && !_.isNil(target))? { url: href, target } : {}
    }
    if (event === 'openView') {
      params = (!_.isNil(cid) && !_.isNil(vid)) ? { cid, vid } : {}
    }
    if (event === 'openNativeView') {
      params =  { nativePage, externalUrl }
    }
    if (event === 'shareAndGrantCoupon') {
      const {shareInfo, modalInfo} = this.props;
      params =  {shareInfo,modalInfo};
    }
    if (event === 'openAudio') {
      params = !_.isNil(cid) ? { cid } : {}
    }
    if (event === 'openVideoChannel') {
      params =  { nativePath }
    }
    if (event === 'openReader') {
      params =  { nativePath }
    }
    const clickEvent = !_.isEmpty(event) ? (event !== 'navLink' ? function () {  CrgtEvent[`${event}`](params)}: ()=>{handleChangePage && handleChangePage(router)}) :null;
    
    return (
      <div className={containerClass} style={style}  onClick={clickEvent}>{this.props.children}</div>
    )
  }
}

 